/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SingleLineStringTagDefinitionWithLinks } from '../models/single-line-string-tag-definition-with-links';
@Injectable({
  providedIn: 'root',
})
class SingleLineStringDefinitionsWithLinksService extends __BaseService {
  static readonly SingleLineStringDefinitionsWithLinksGetPath = '/single-line-string-definitions-with-links/{tagDefinitionId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the single line string tag definition with links
   * @param params The `SingleLineStringDefinitionsWithLinksService.SingleLineStringDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SingleLineStringDefinitionsWithLinksGetResponse(params: SingleLineStringDefinitionsWithLinksService.SingleLineStringDefinitionsWithLinksGetParams): __Observable<__StrictHttpResponse<SingleLineStringTagDefinitionWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/single-line-string-definitions-with-links/${encodeURIComponent(String(params.tagDefinitionId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SingleLineStringTagDefinitionWithLinks>;
      })
    );
  }
  /**
   * Returns the single line string tag definition with links
   * @param params The `SingleLineStringDefinitionsWithLinksService.SingleLineStringDefinitionsWithLinksGetParams` containing the following parameters:
   *
   * - `tagDefinitionId`: GUID of the tag definition
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  SingleLineStringDefinitionsWithLinksGet(params: SingleLineStringDefinitionsWithLinksService.SingleLineStringDefinitionsWithLinksGetParams): __Observable<SingleLineStringTagDefinitionWithLinks> {
    return this.SingleLineStringDefinitionsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as SingleLineStringTagDefinitionWithLinks)
    );
  }
}

namespace SingleLineStringDefinitionsWithLinksService {

  /**
   * Parameters for SingleLineStringDefinitionsWithLinksGet
   */
  export interface SingleLineStringDefinitionsWithLinksGetParams {

    /**
     * GUID of the tag definition
     */
    tagDefinitionId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { SingleLineStringDefinitionsWithLinksService }